import ServicoFiscalModel from "../models/servicoFiscalModel";

import { IService } from "./base/iService";

export default class ServicoFiscalService extends IService<ServicoFiscalModel> {
    constructor() {
        super("ServicoFiscal");
    }
}
